import { http } from '@haohan/clw-utils'

const URL = '/api/v1/projects'

/**
 * 查询模块
 */
export function queryModuleList(projectId: string, params?: any) {
  const _p = params || {
    orders: [
      {
        mode: 'ASC',
        expression: 'sort'
      }
    ]
  }
  return http.request({
    method: 'post',
    url: `${URL}/${projectId}/modules/query`,
    data: _p
  })
}

/**
 * 新增模块
 */
export function addModule(projectId: string, data?: any) {
  return http.request({
    method: 'post',
    url: `${URL}/${projectId}/modules`,
    data
  })
}

/**
 * 修改模块
 */
export function editModule(projectId: string, moduleId: string, data?: any) {
  return http.request({
    method: 'put',
    url: `${URL}/${projectId}/modules/${moduleId}`,
    data
  })
}

/**
 * 删除模块
 */
export function deleteModule(projectId: string, moduleId: string) {
  return http.request({
    method: 'delete',
    url: `${URL}/${projectId}/modules/${moduleId}`
  })
}

/**
 * 移动模块
 */
export function moveModule(projectId: string, data: any) {
  return http.request({
    method: 'put',
    url: `${URL}/${projectId}/modules/move`,
    data
  })
}
